import useFavicon from "hooks/useFavicon";
import React, { useEffect } from "react";
import { isInternetExplorer } from "utils/browser";
import UnsupportedBrowserPage from "../UnsupportedBrowserPage";
import Demonstration from "./Demonstration";
import Head from "./Head";
import IParqueModules from "./IParqueModules";
import Newsletter from "./Newsletter";
import { BackgroundContainer, StyledFooter } from "./styles";

const LandingPage: React.FC = () => {
  useFavicon("/favicon.svg");

  useEffect(() => {
    if (!window.location.hash) {
      return;
    }

    const element = document.querySelector(window.location.hash);

    if (!element) {
      return;
    }

    element.scrollIntoView({
      behavior: "smooth",
    });
  }, []);

  return isInternetExplorer ? (
    <UnsupportedBrowserPage />
  ) : (
    <>
      <BackgroundContainer>
        <Head />
        <IParqueModules />
        <Newsletter />
      </BackgroundContainer>
      <StyledFooter />
      <Demonstration />
    </>
  );
};

export default LandingPage;
